module.exports = __webpack_public_path__ + "static/img/manual_zh_3.aa1fa0b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_3.png
// module id = Tx54
// module chunks = 4